type TTasklineView = 'hit' | 'task';
export const tasklineHitViews: TTasklineView[] = ['hit', 'task'];

export type TTasklineHitNavParams = {
  id: string
  taskId: string
  hitId?: string
  projectId?: string
  tenant: string
  view: TTasklineView
};
